// extracted by mini-css-extract-plugin
export default {"viewWrapper":"index_viewWrapper__938Cq","viewLeft":"index_viewLeft__v5wEk"};